import {
  addDays,
  addMonths,
  addWeeks,
  format,
  isSameDay,
  isSameMonth,
  isSameWeek,
  startOfDay,
  startOfMonth,
  startOfWeek,
} from 'date-fns'

import { CalendarGridMode } from '../../../../constants/calendarGrid'
import {
  DATE_API_DATA_FORMAT_SHORT,
  DATE_DAY_FORMAT,
  DATE_DAY_MONTH_SHORT_FORMAT,
  DATE_WEEKDAY_NAME_ABBR_FORMAT,
} from '../../../../constants/date'
import { getMonthDays } from '../../../DateTime'
import {
  CALENDAR_GRID_DAY_COUNT,
  CALENDAR_GRID_WEEK_STARTS_ON,
} from '../../CalendarGrid.constants'
import { getIsCalendarGridMonthMode } from '../../CalendarGrid.utils'

import {
  CALENDAR_GRID_AGENDA_DAY_COUNT,
  CALENDAR_GRID_DAY_MODE_DAY_COUNT,
} from './useCalendarGrid.constants'

function toCalendarGridDay({ anchor, date, isMonthMode, locale }) {
  return {
    date: format(date, DATE_API_DATA_FORMAT_SHORT),
    dayLabel: format(
      date,
      isMonthMode ? DATE_DAY_FORMAT : DATE_DAY_MONTH_SHORT_FORMAT
    ),
    isCurrentMonth: isSameMonth(anchor, date),
    weekdayLabel: format(date, DATE_WEEKDAY_NAME_ABBR_FORMAT, { locale }),
  }
}

function getCalendarGridRangeDayCount(mode) {
  switch (mode) {
    case CalendarGridMode.day:
      return CALENDAR_GRID_DAY_MODE_DAY_COUNT
    case CalendarGridMode.agenda:
      return CALENDAR_GRID_AGENDA_DAY_COUNT
    default:
      return CALENDAR_GRID_DAY_COUNT
  }
}

export function getCalendarGridAnchor({ anchorOffset, mode, today }) {
  switch (mode) {
    case CalendarGridMode.month:
      return addMonths(startOfMonth(today), anchorOffset)
    case CalendarGridMode.day:
      return addDays(startOfDay(today), anchorOffset)
    case CalendarGridMode.agenda:
      return startOfDay(today)
    default:
      return addWeeks(
        startOfWeek(today, { weekStartsOn: CALENDAR_GRID_WEEK_STARTS_ON }),
        anchorOffset
      )
  }
}

export function getIsCalendarGridTodayVisible({ anchor, mode, today }) {
  switch (mode) {
    case CalendarGridMode.month:
      return isSameMonth(anchor, today)
    case CalendarGridMode.day:
      return isSameDay(anchor, today)
    case CalendarGridMode.agenda:
      return true
    default:
      return isSameWeek(anchor, today, {
        weekStartsOn: CALENDAR_GRID_WEEK_STARTS_ON,
      })
  }
}

export function getCalendarGridRange({ anchor, locale, mode }) {
  const isMonthMode = getIsCalendarGridMonthMode(mode)

  const dates = isMonthMode
    ? getMonthDays(anchor, locale)
    : Array.from({ length: getCalendarGridRangeDayCount(mode) }, (_, index) =>
        addDays(anchor, index)
      )

  const days = dates.map(date =>
    toCalendarGridDay({ anchor, date, isMonthMode, locale })
  )

  return {
    days,
    from: days[0].date,
    to: days[days.length - 1].date,
    weekdays: days
      .slice(0, CALENDAR_GRID_DAY_COUNT)
      .map(day => day.weekdayLabel),
  }
}
